import DefaultUtils from '@/utils/default.utils'
import NotificacoesService from '@/services/bussines/notificacoes.service'
import VueCookies from "vue-cookies"

const _data_source = DefaultUtils.jsonPaseStr(DefaultUtils.base64(DefaultUtils.getCookie('notification_selfinvest')))

const _painel = DefaultUtils.jsonPaseStr(DefaultUtils.base64(DefaultUtils.getCookie('notification_painel')))

const state = {
  data_source: typeof _data_source === 'boolean' ? [] : _data_source,
  painel: typeof _painel === 'boolean' ? "" : _painel,
  notificationQtd: 0,
}

// getters
const getters = {
  notificationQtd: state => state.notificationQtd,
  notificacoesLst: state => state.data_source,
  lastUpdatedDataSourcePainel: state => state.painel
}

// actions
const actions = {

  async geNotification({ commit }) {
   
    const response = await NotificacoesService.List()

    commit("setNotification", response)
  },

  async removeItemNotif({ commit }, rid) {
    
    const response = await NotificacoesService.Remove(rid)

    commit('removeItem', rid)
  },

   updateDataPainel({ commit },data) {
    commit("setUpdateDataPainel", data)
  },
}

// mutations
const mutations = {

  setUpdateDataPainel(state, resp) {
    state.painel =  DefaultUtils.formatDateIsoToBr(resp,'dd/MM/yyyy H:mm:ss')
    VueCookies.set("notification_painel", DefaultUtils.base64(JSON.stringify(state.painel)))
  },

  setNotification(state, resp) {
    // console.log(state)
    // console.log(resp)
    state.data_source = resp
    state.notificationQtd = state.data_source.length

  
    if (state.notificationQtd > 0) {
      VueCookies.set("notification_selfinvest", DefaultUtils.base64(JSON.stringify(state.data_source)))
    } else {
      DefaultUtils.removeCookie("notification_selfinvest")
    }
  },
   removeItem(state, rid) {

    state.data_source = state.data_source.filter(a => {
      return a.RID != rid
    })
    state.notificationQtd = state.data_source.length

    if (state.data_source.length > 0) {
      DefaultUtils.setCookie('notification_selfinvest', DefaultUtils.base64(JSON.stringify(state.data_source)))
    } else {
      DefaultUtils.removeCookie('notification_selfinvest')
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}